import { render, staticRenderFns } from "./giftActivityPublicityChart.vue?vue&type=template&id=99cd9c04&"
import script from "./giftActivityPublicityChart.vue?vue&type=script&lang=js&"
export * from "./giftActivityPublicityChart.vue?vue&type=script&lang=js&"
import style0 from "./giftActivityPublicityChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99cd9c04')) {
      api.createRecord('99cd9c04', component.options)
    } else {
      api.reload('99cd9c04', component.options)
    }
    module.hot.accept("./giftActivityPublicityChart.vue?vue&type=template&id=99cd9c04&", function () {
      api.rerender('99cd9c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/giftActivity/giftActivityPublicityChart.vue"
export default component.exports